import { memo, useContext } from "react";
import PropTypes from "prop-types";
import BadgeList from "app/pages/.shared/ColoredProductBadge/BadgeList";
import { PRODUCT_TAG_CODES } from "app/constants";
import { BadgeItem } from "app/components/ui/badge/BadgeItem";
import AppGlobalsContext from "app/AppGlobalsContext";
import { isBrandWithAccount } from "app/utils/utils";
import "./ProductTopBar.scss";

const getUnbeatableOffer = ({ unbeatableOfferTag, shouldDisplayMemberOnlyTag }) => {
	if (shouldDisplayMemberOnlyTag) {
		return "membersOnly";
	}

	if (unbeatableOfferTag === PRODUCT_TAG_CODES.LIMITED_TIME) {
		return "limited";
	} else {
		return "lastDays";
	}
};

const ProductTopBar = ({ badges = [], isFavorite, isTour = false, unbeatableOfferTag }) => {
	const { brand, isUserConnected, strategy } = useContext(AppGlobalsContext);
	const shouldDisplayMemberOnlyTag = isBrandWithAccount({ brand, strategy }) && !isUserConnected;

	const unbeatableOffer = getUnbeatableOffer({ unbeatableOfferTag, shouldDisplayMemberOnlyTag });

	return (
		<div className="product-top-bar" data-testid="product-top-bar">
			<div className="product-top-bar__badges">
				{badges.length > 0 && <BadgeList badges={badges} />}

				{unbeatableOfferTag && <BadgeItem type={unbeatableOffer} />}

				{isFavorite && !unbeatableOfferTag && <BadgeItem type="topPicks" />}

				{isTour && <BadgeItem type="tours" />}
			</div>
		</div>
	);
};

ProductTopBar.propTypes = {
	isFavorite: PropTypes.bool,
	isTour: PropTypes.bool,
	unbeatableOfferTag: PropTypes.oneOf([
		PRODUCT_TAG_CODES.LIMITED_TIME,
		PRODUCT_TAG_CODES.LAST_DAY,
	]),
	badges: PropTypes.array,
};

export default memo(ProductTopBar);
